<div id="divSpinner" *ngIf="visible" >
    <div id="subDivSpinner">
        <p-progressSpinner mode="indeterminate" styleClass="custom-spinner"></p-progressSpinner>
    </div>
</div>
